import React from 'react';
import {
  OPTION_SELECTOR,
  OptionSelector,
} from './widgets/optionSelector/optionSelector';

import {
  SINGLE_SELECT_WIDGET,
  SingleSelectWidget,
} from './widgets/singleSelectWidget/singleSelectWidget';

import {
  SUGGESTIONS_WIDGET,
  SuggestionsChatWidget,
} from './widgets/suggestions/suggestions';

import type {
  ChatMessageWidget,
  WidgetContext,
} from '@wix/chat-widget-common-widgets';

const widgetRegistry = [
  [OPTION_SELECTOR, OptionSelector],
  [SINGLE_SELECT_WIDGET, SingleSelectWidget],
  [SUGGESTIONS_WIDGET, SuggestionsChatWidget],
];

export const WIDGETS_NAMES = widgetRegistry.reduce(
  (widgetsNames: Record<string, string>, widget) => {
    const widgetName = widget[0] as string;

    widgetsNames[widgetName] = widgetName;

    return widgetsNames;
  },
  {},
);

export const getEditorWidgets = (
  context: WidgetContext = {
    send: () => {
      console.warn('[getChatWidgets()] "sendUserMessage" not passed');
      return Promise.resolve();
    },
    onWidgetAction: () => {
      console.warn('[getChatWidgets()] "onWidgetAction" not passed');
    },
    httpClient: undefined,
    theme: 'light',
  },
) => {
  return widgetRegistry.map(([widgetName, WidgetComponentImpl]) => {
    return {
      widgetName,
      component: (data: any) => {
        return <WidgetComponentImpl data={data} context={context} />;
      },
    };
  }) as ChatMessageWidget[];
};
